import { ClickEvent, CrudDecorator, DataDisplayEvent, DataSourceAction, DataSourceExecutionEvent, DataSourceMode, DataSourceValidationEvent, DropdownSelectionEvent, Layout, LookupModelSelectionEvent, OpenType, TableRow, Textbox, Toast, ValidationResult } from "@mcleod/components";
import { AutogenLayoutDetentionDefinition } from "./autogen/AutogenLayoutDetentionDefinition";
import { Api, DateRange, EmailUtil, ModelRow, StringUtil } from "@mcleod/core";
import { DuplicateIdProps } from "./DuplicateId";
import { CommonDialogs } from "@mcleod/common";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "detention_def",
    screenName: "Detention Definitions",
    navigateToUrl: "lme/settlement/dispatch/DetentionDefinition?mode=update&key="
};

export class DetentionDefinition extends AutogenLayoutDetentionDefinition {
    copiedDefinition: boolean = false;

    override onLoad(): void {
            this.textboxEmailList.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                return this.emailDomainValidator(this.textboxEmailList, mode);
            };
            this.textboxEmailCcList.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                return this.emailDomainValidator(this.textboxEmailCcList, mode);
            };

            this.mainDataSource.addValidationListener((event: DataSourceValidationEvent) => this.validateWarnFreeHours(event));
    }

    async buttonCopyDetentionDefOnClick(event: ClickEvent) {
        this.buttonCopyDetentionDef.busy = true;
        try {
            const layout = Layout.getLayout(this.layoutName);
            const decorator = new CrudDecorator({
                pseudoNavigateUrl: "/" + this.layoutName + "?mode=add",
                layout: layout,
                mode: DataSourceMode.ADD,
                headerProps: {
                    showClose: true,
                    showSaveAndClose: true,
                },
                doAfterSlideIn: async () => {
                    const detentionDef = decorator.layout as DetentionDefinition;
                    detentionDef.mainDataSource.setRowsAndMode(DataSourceMode.ADD, [await this.mainDataSource.createBlankRow()]);
                    const rowsToCopy = this.sourceDetentionDefChg.data.map((row: ModelRow, index) => {
                        const detentionChargeRow = new ModelRow("lme/dispatch/detention-def-chg", true, row.data);
                        detentionChargeRow.set("id", null);
                        detentionChargeRow.setValueAndLookupModelData("charge_id", row.get("charge_id"), row.getLookupModelData("charge_id"));
                        detentionChargeRow.setValueAndLookupModelData("customer_id", row.get("customer_id"), row.getLookupModelData("customer_id"));
                        detentionChargeRow._appending = true;
                        return detentionChargeRow;
                    });
                    detentionDef.sourceDetentionDefChg.setRowsAndMode(DataSourceMode.ADD, rowsToCopy);
                    detentionDef.sourceDetentionDefChg.displayDataInBoundComponents();
                    detentionDef.mainDataSource.activeRow.setValues(this.activeRow.data);
                    detentionDef.mainDataSource.activeRow.set("id", null);
                    detentionDef.mainDataSource.activeRow.set("effective_date", new Date());
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("customer_id", this.activeRow.get("customer_id"), this.activeRow.getLookupModelData("customer_id"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("stop_location_id", this.activeRow.get("stop_location_id"), this.activeRow.getLookupModelData("stop_location_id"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("commodity_id", this.activeRow.get("commodity_id"), this.activeRow.getLookupModelData("commodity_id"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("revenue_code_id", this.activeRow.get("revenue_code_id"), this.activeRow.getLookupModelData("revenue_code_id"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("order_type_id", this.activeRow.get("order_type_id"), this.activeRow.getLookupModelData("order_type_id"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("contact_name", this.activeRow.get("contact_name"), this.activeRow.getLookupModelData("contact_name"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("email_profile_id", this.activeRow.get("email_profile_id"), this.activeRow.getLookupModelData("email_profile_id"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("cmp_driver_earning_code", this.activeRow.get("cmp_driver_earning_code"), this.activeRow.getLookupModelData("cmp_driver_earning_code"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("cmp_team_earning_code", this.activeRow.get("cmp_team_earning_code"), this.activeRow.getLookupModelData("cmp_team_earning_code"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("ownop_earning_code", this.activeRow.get("ownop_earning_code"), this.activeRow.getLookupModelData("ownop_earning_code"));
                    detentionDef.mainDataSource.activeRow.setValueAndLookupModelData("carrier_earning_code", this.activeRow.get("carrier_earning_code"), this.activeRow.getLookupModelData("carrier_earning_code"));
                    detentionDef.mainDataSource.displayDataInBoundComponents();
                    detentionDef.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
                        if (event.getAction() === DataSourceAction.ADD) {
                            this.copiedDefinition = true;
                        }
                    });
                },
            });
            decorator.slideIn({ speed: 200 });
        }
        catch (e) {
            CommonDialogs.showError(e);
        }
        finally {
            this.buttonCopyDetentionDef.busy = false;
        }
    }

    validateWarnFreeHours(event?: DataSourceValidationEvent) {
        try {
            let hr: number, min: number, freeMin: number, warnMin: number;
            let tmpTxt = this.mainDataSource.activeRow.get("free_time_hours");
            if (StringUtil.isEmptyString(tmpTxt)) {
                hr = 0;
            } else {
                hr = tmpTxt
            }
            freeMin = hr * 60;
            tmpTxt = this.mainDataSource.activeRow.get("free_time_minutes");
            if (StringUtil.isEmptyString(tmpTxt)) {
                min = 0;
            } else {
                min = tmpTxt
            }
            freeMin += min;
            tmpTxt = this.mainDataSource.activeRow.get("warn_hours");
            if (StringUtil.isEmptyString(tmpTxt)) {
                hr = 0;
            } else {
                hr = tmpTxt
            }
            warnMin = hr * 60;
            tmpTxt = this.mainDataSource.activeRow.get("warn_minutes");
            if (StringUtil.isEmptyString(tmpTxt)) {
                min = 0;
            } else {
                min = tmpTxt
            }
            warnMin += min;
            if (warnMin >= freeMin) {
                event.validationResults.push({
                    isValid: false,
                    caption: "Warn hours/minutes must be less than free time",
                    component: this.textboxWarnMinutes
                });
            }
        } catch (ex) {
            event.validationResults.push({
                isValid: false,
                validationMessage: `Error validating time fields: ${ex.message}`,
                component: this.textboxFreeTimeHours
            });
        }
    }

    textboxNotifyWarningOnDataDisplay(event: DataDisplayEvent) {
        if (event.rowData) {
            this.syncNotifyFields();
        }
    }

    textboxNotifyAfterDropdownSelection(event: DropdownSelectionEvent) {
        this.syncNotifyFields();
    }

    syncNotifyFields() {
        if (this.mainDataSource.activeRow.get("notify_warning") == "N") {
            this.textboxWarnHours.required = false;
            this.textboxWarnMinutes.required = false;
        }
        else {
            this.textboxWarnHours.required = true;
            this.textboxWarnMinutes.required = true;
        }
        if (
            (this.mainDataSource.activeRow.get("notify_arrival") == "N" &&
            this.mainDataSource.activeRow.get("notify_warning") == "N" &&
            this.mainDataSource.activeRow.get("notify_departure") == "N" &&
            this.mainDataSource.activeRow.get("notify_charge") == "N") ||
            this.mainDataSource.activeRow.get("global_definition") == "Y"
        ) {
            this.textboxEmailList.required = false;
            this.textboxContactName.required = false;
        }
        else {
            this.textboxEmailList.required = true;
            this.textboxContactName.required = true;
        }
    }


    textboxChargeIdOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection() === true) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            tableRow.data.set("descr", event.selection.get("descr"));
            tableRow.displayComponentValues();
        }
    }

    sourceDetentionHistBeforeExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            event.filter.status = "!V";
            const dateRange = DateRange.parseDateRangeWithKeywords("t-5,t").getFormattedString().split("-");
            event.filter.creation_date =  `>=${dateRange[0]}&<=${dateRange[1]}`;
        }
    }

    sourceDetentionDefAfterExecution(event: DataSourceExecutionEvent) {
        this.setGlobalDefinitionFields();
        this.layoutDetentionHistoryTable.tableDetentionHistory.allowAdvancedSearch = false;
        this.layoutDetentionHistoryTable.tableDetentionHistory.defaultOpenType = OpenType.NEW_TAB_WITH_SWITCH;
        const dateRange = DateRange.parseDateRangeWithKeywords("t-5,t").getFormattedString().split("-");
        const filter = {
            type: "D",
            detention_def_id: this.activeRow?.get("id"),
            status: "!V",
            creation_date: `>=${dateRange[0]}&<=${dateRange[1]}`
        };
        this.layoutDetentionHistoryTable.layoutDetentionSummary.setNewTabFilter(filter);
    }

    setGlobalDefinitionFields() {
        if (this.mainDataSource.activeRow.get("global_definition") == "Y") {
            this.mainDataSource.activeRow.set("contact_name", null);
            this.mainDataSource.activeRow.set("email_list", null);
            this.mainDataSource.activeRow.setValueAndLookupModelData("customer_id", null, null);
            this.mainDataSource.activeRow.setValueAndLookupModelData("stop_location_id", null, null);
            this.mainDataSource.activeRow.setValueAndLookupModelData("commodity_id", null, null);
            this.mainDataSource.activeRow.setValueAndLookupModelData("revenue_code_id", null, null);
            this.mainDataSource.activeRow.setValueAndLookupModelData("order_type_id", null, null);
            this.textboxCustomerId.required = false;
            this.textboxCustomerId.visible = false;
            this.textboxPriority.visible = false;
            this.textboxPriority.required = false;
            this.textboxAppliesTo.visible = false;
            this.textboxAppliesTo.required = false;
            this.textboxRevenueCodeId.visible = false;
            this.textboxStopLocationId.visible = false;
            this.textboxCommodityId.visible = false;
            this.textboxOrderTypeId.visible = false;
            this.textboxEmailList.required = false;
            this.textboxEmailList.visible = false;
            this.textboxEmailCcList.visible = false;
            this.textboxContactName.required = false;
            this.textboxContactName.visible = false;
            this.mainDataSource.displayDataInBoundComponents();
        }
        else {
            this.textboxCustomerId.required = true;
            this.textboxCustomerId.visible = true;
            this.textboxPriority.visible = true;
            this.textboxPriority.required = true;
            this.textboxAppliesTo.visible = true;
            this.textboxAppliesTo.required = true;
            this.textboxRevenueCodeId.visible = true;
            this.textboxStopLocationId.visible = true;
            this.textboxCommodityId.visible = true;
            this.textboxOrderTypeId.visible = true;
            this.textboxEmailList.required = true;
            this.textboxEmailList.visible = true;
            this.textboxEmailCcList.visible = true;
            this.textboxContactName.required = true;
            this.textboxContactName.visible = true;
        }
    }

    textboxContactNameBeforeLookupModelSearch(event) {
        if (this.activeRow.isNull("customer_id"))
            event.preventDefault();
        else {
            event.filter.parent_row_id = this.activeRow.get("customer_id");
            event.filter.parent_row_type = "C";
            event.filter.is_active = "Y";
        }
    }

    switchGlobalDefOnChange(event) {
        this.setGlobalDefinitionFields();
    }

    private emailDomainValidator(textbox: Textbox, mode: DataSourceMode) {
            if (mode === DataSourceMode.SEARCH) {
                return null;
            }
            if (StringUtil.isEmptyString(textbox.text)) {
                return null;
            }
            const domains = textbox.text.split(",");
            for (const domain of domains) {
                if (!EmailUtil.isValidEmail(domain.trim())) {
                    return { component: textbox, isValid: false, validationMessage: "Invalid domain format. Email domains must be in the following format [abc.com,xyz.com]" }
                }
            }
            return null
    }
}
